module.exports = __webpack_public_path__ + "static/media/achievement-work-buddy.65799141.svg";